import loadable from '@loadable/component';

export const UnpublishedEventPageLoadable = loadable(
  () => import('./UnpublishedEventPage'),
  { resolveComponent: (module) => module.UnpublishedEventPage },
);
